<script setup lang="ts">
import { watch, ref, onMounted } from 'vue';
import { cachedImage } from './ImageCache';
const $props = defineProps<{
  src: string;
}>();

const cacheUrl = ref<string>();

onMounted(() => {
  cachedImage.get($props.src).then((cache) => {
    cacheUrl.value = cache;
  }).catch(() => {});
});

watch(
  () => $props.src,
  (url) => {
    cachedImage.get(url).then((cache) => {
      cacheUrl.value = cache;
    }).catch(() => {});
  },
);
</script>

<template>
  <img :src="cacheUrl" alt="" v-bind="$attrs" />
</template>
